import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'
import { filterRows } from '../utils/filterRowsByTerm'

const useSystemEvents = () => {
  const [loading, setLoading] = useState(true)
  const [rows, setRows] = useState([])
  const [resetRowsState, setResetRowsState] = useState([])
  const [filterOptions, setFilterOptions] = useState(null)
  const [selectedFilterOptions, setSelectedFilterOptions] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [dateRange, setDateRange] = useState([new Date(), new Date()])
  const [selectedTab, setSelectedTab] = useState(0)

  const handleType = e => {
    const inputValue = e.target.value
    setInputValue(inputValue)
    filterRows({
      filterByTerm: inputValue,
      rows: filterRowsByOptions(),
      defineRows: setRows,
    })
  }

  const createRows = ({ data }) => {
    const rows = data?.map(({ id, date, type, action, user, eventType }) => ({
      id,
      date,
      type,
      action,
      eventType,
      employee: user?.name,
    }))

    setResetRowsState(rows)

    return rows || []
  }

  const filterRowsByOptions = () => {
    let rows = resetRowsState

    if (selectedFilterOptions?.eventTypes.length > 0) {
      rows = rows.filter(row =>
        selectedFilterOptions.eventTypes.includes(row.eventType),
      )
    }

    return rows
  }

  const getPossibleFilters = ({ data }) => {
    const filters = {
      eventTypes: [],
    }

    data.forEach(({ eventType }) => {
      if (eventType && !filters.eventTypes.includes(eventType))
        filters.eventTypes.push(eventType)
    })

    return filters
  }

  const handleDateRange = ({ value }) => {
    setDateRange(value)
  }

  const handleChangeSelectedTab = (_, newValue) => {
    setSelectedTab(newValue)
    handleDateRange({ value: [new Date(), new Date()] })
  }

  const fetchData = useCallback(
    async ({ dateRange }) => {
      setLoading(true)
      try {
        const { data } = await RequestService.getSystemEvents({
          startDate: dateRange[0],
          endDate: dateRange[1],
        })

        const rows = createRows({ data })
        const filters = getPossibleFilters({ data })

        setFilterOptions(filters)
        setRows(rows)
      } catch (e) {
        console.log('useSystemEvents', e)
      }

      setLoading(false)
    },
    [selectedTab],
  )

  useEffect(() => {
    if (dateRange) fetchData({ dateRange })
  }, [dateRange])

  useEffect(() => {
    const filteredRows = filterRowsByOptions()

    if (resetRowsState.length > 0) {
      setRows(filteredRows)
      setInputValue('')
    }
  }, [selectedFilterOptions])

  useEffect(() => {
    if (dateRange) {
      localStorage.setItem('@ialerta/reset-filters', true)
      setInputValue('')
      setSelectedFilterOptions(null)
    }
  }, [dateRange])

  return {
    loading,
    rows,
    filterOptions,
    setSelectedFilterOptions,
    inputValue,
    handleType,
    dateRange,
    handleDateRange,
    selectedTab,
    handleChangeSelectedTab,
    selectedFilterOptions,
  }
}

export default useSystemEvents
